/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_radar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online radar / spider chart maker. Paste metrics and values to compare several items across multiple dimensions at once.`)
};

const es_radar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador gratuito de gráficos de radar / araña online. Pega métricas y valores para comparar varios elementos en múltiples dimensiones a la vez.`)
};

const de_radar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Radar-/Spinnendiagramm-Ersteller. Fügen Sie Kennzahlen und Werte ein, um mehrere Elemente über mehrere Dimensionen gleichzeitig zu vergleichen.`)
};

const nl_radar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online radar-/spiderdiagrammaker. Plak metrics en waarden om meerdere items tegelijk over meerdere dimensies te vergelijken.`)
};

const fr_radar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur gratuit de diagramme radar / araignée en ligne. Collez des métriques et des valeurs pour comparer plusieurs éléments selon plusieurs dimensions à la fois.`)
};

const it_radar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore gratuito di grafici radar / a ragno online. Incolla metriche e valori per confrontare più elementi su più dimensioni contemporaneamente.`)
};

const pt_br2_radar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador gratuito online de gráfico de radar / aranha. Cole métricas e valores para comparar vários itens em múltiplas dimensões ao mesmo tempo.`)
};

const pt_radar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador gratuito de gráficos radar / aranha online. Cole métricas e valores para comparar vários itens em múltiplas dimensões ao mesmo tempo.`)
};

const ja_radar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンラインレーダー／スパイダーチャート作成ツール。指標と値を貼り付けると、複数の項目を複数の次元にわたって一度に比較できます。`)
};

const zh_radar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线雷达图 / 蜘蛛图制作工具。粘贴指标和数值，即可一次在多个维度上比较多个项目。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const radar_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.radar_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("radar_meta_description", locale)
	if (locale === "en") return en_radar_meta_description(inputs)
	if (locale === "es") return es_radar_meta_description(inputs)
	if (locale === "de") return de_radar_meta_description(inputs)
	if (locale === "nl") return nl_radar_meta_description(inputs)
	if (locale === "fr") return fr_radar_meta_description(inputs)
	if (locale === "it") return it_radar_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_radar_meta_description(inputs)
	if (locale === "pt") return pt_radar_meta_description(inputs)
	if (locale === "ja") return ja_radar_meta_description(inputs)
	return zh_radar_meta_description(inputs)
};